import styled from '../../styles/styled';
export const ButtonColumn = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    '>*:not(:last-of-type)': {
        marginBottom: theme.spacing.m,
    },
}));
//# sourceMappingURL=button_column.js.map